module.exports = {
	"useEval": "true",
	"holderId": "#holder",
	"datepicker": {
		"selector": "[role=datepicker]"
	},
	"monthpicker": {
		"selector": "[role=monthpicker]"
	},
	"loader": {
		"selector": "[role=loader-group], .loader",
		"html": "<div role='loader-group'><div class='loader'></div></div>",
		"class": "loader"
	},
	"feedback": {
		"class": "alert",
		"html": "<div></div>",
		"error_class": "error",
		"warning_class": "warning",
		"inprogress_class": "progress",
		"correct_class": "ok"
	},
	"links": {
		"ajax": "[role=ajax]",
		"ajax_no_loader": "[role=ajax-nl]",
		"json": "[role=json]",
		"loop": "[role=loop]",
		"link": "[role=link]"
	},
	"forms": {
		"json": "[role=json-form]",
		"ajax": "[role=ajax-form]",
		"upload": "[role=upload-form]",
		"group": "[role=form-group]",
		"error_class": "has-error",
		"sending_class": "sending",
		"google_captcha": "[role=captcha]",
		"google_captcha_key": "6LfYNCgTAAAAAArFbWWNCAYgmurUkljOQ1KqYMn6"
	},
	"paginator": {
		"selector": "[role=paginator]",
		"content": "[role=page-content]"
	},
	"menu": {
		"selector": "[role=menu]",
		"item": "[role=menu-item]"
	},
	"menu_tab": {
		"selector": "[role=tab-menu]",
		"item": "[role=tab-nav]",
		"tab_new": "[role=tab-new]"
	},
	"dropdown": {
		"selector": "[role=dropdown]",
		"item": "[role=dropdown-item]"
	},
	"input_to_select": {
		"selector": "[role=combo]",
		"separator": "::"
	},
	"login_required": {
		"selector": "[role=doLogin]",
		"template": "/web/sessionExpired"
	},
	"confirm": {
		"selector": "[role=confirm]"
	},
	"activate": {
		"selector": "[role=activate]"
	},
	"delete": {
		"selector": "[role=delete]"
	},
	"toggle": {
		"selector": "[role=toggle-detail]"
	},
	"checkboxgroup": {
		"selector": "[role=checkbox-group]"
	},
	"radiogroup": {
		"selector": "[role=radio-group]"
	},
	"modal": {
		"id": "#modal-window",
		"selectors": {
			"open": "[role=open-modal]",
			"close": "[role=close-modal]"
		},
		"top": "200",
		"closeButton": "<div role='close-modal' class='close-button icon icon-remove-sign c-red pointer t-fs22'></div>"
	}
};


//////////////////
// WEBPACK FOOTER
// ./devel/config.json
// module id = 16
// module chunks = 0